import { DatePipe, NgFor } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ConfirmationService, PrimeTemplate } from 'primeng/api';
import { DrawerModule } from 'primeng/drawer';
import { SkeletonModule } from 'primeng/skeleton';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { UtilsService } from 'src/app/utils/utils.service';
import { TableDirective } from '../../../../shared/directives/p-table.directive';
import { AdminFeasibilityService } from './admin-feasibility.service';
import { ManageAdminFeasibilityComponent } from './manage-admin-feasibility/manage-admin-feasibility.component';


@Component({
    selector: 'app-admin-feasibility',
    templateUrl: './admin-feasibility.component.html',
    standalone: true,
    imports: [TableModule, TableDirective, PrimeTemplate, TooltipModule, NgFor, SkeletonModule, DrawerModule, ManageAdminFeasibilityComponent, DatePipe, TranslateModule]
})
export class AdminFeasibilityComponent implements OnInit {

    constructor(
		public readonly adminFeasibilityService: AdminFeasibilityService,
		public readonly utilsService: UtilsService,
		private readonly translateService: TranslateService,
		private readonly confirmationService: ConfirmationService
    ) { }

    async ngOnInit(): Promise<void> {
        await this.adminFeasibilityService.fetchFeasibilityRules();
    }

    createFeasibilityRule(): void {
        this.adminFeasibilityService.selectedRule = undefined;
        this.adminFeasibilityService.selectedRuleIndex = undefined;
        this.adminFeasibilityService.isSidebarVisible = true;
    }

    updateFeasibilityRule(rulePosition: number): void {
        this.adminFeasibilityService.selectedRule = this.adminFeasibilityService.feasibilityRules[rulePosition];
        this.adminFeasibilityService.selectedRuleIndex = rulePosition;
        this.adminFeasibilityService.isSidebarVisible = true;
    }

    confrimDeleteFeasibilityRule(event: Event, rulePosition: number): void {
        if (!event || !event.target) return;

        this.confirmationService.confirm({
            target: event.target,
            message: this.translateService.instant('ADMINISTRATION.FEASIBILITY.DELETE_CONFIRMATION'),
            acceptLabel: this.translateService.instant('BUTTON.YES'),
            rejectLabel: this.translateService.instant('BUTTON.NO'),
            accept: () => {
                this.adminFeasibilityService.deleteFeasibilityRule(rulePosition).catch(error => {console.error(error);});
            }
        });
    }

    translateOperator(operator: string): string {
        return this.translateService.instant(`ADMINISTRATION.FEASIBILITY.OPERATORS.${operator}`);
    }
}
